import { client } from '@/client/client.gen.ts';
import axiosInstance from '@/lib/axiosInstance.ts';
import { AxiosStatic } from 'axios';

export function configureClient() {
	client.setConfig({
		// ...axiosInstance.defaults
		axios: axiosInstance as AxiosStatic,
		baseURL: import.meta.env.VITE_API_URL,
		withCredentials: true,
	});
}
